import { connect } from 'react-redux';
import { StoreState } from '../../../reducers/index';
import StandardCookie from '../../../components/CookieNotification/StandardCookie';
import { DEFAULT_COOKIE_URLS } from '../constants';

const mapStateToProps = (state: StoreState) => {
	const {
		galleryInfos: { template: { cookie } },
		appInfos: { areCookieAccepted },
		i18n: { locale },
	} = state;

	return {
		isDisplayed: !!cookie && cookie.enabled === 'true' && cookie.gdpr === 'false' &&
			!areCookieAccepted,
		url: cookie && cookie.url || DEFAULT_COOKIE_URLS[locale],
	};
};

export default connect(mapStateToProps)(StandardCookie);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/CookieNotification/StandardCookie/index.ts